<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="4" :sm="6">
            <a-form-item :label="'类型'">
              <a-select default-value='' style='width: 120px' v-model='queryParam.loanType'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='1'>
                  首贷
                </a-select-option>
                <a-select-option value='2'>
                  复贷
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" :md="6" :sm="8">
            <a-form-item :label="'产品类型'">
              <a-select
                v-model='queryParam.appSsid'
                mode='multiple'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
      >
      </a-table>
      <br/>
      <a-form layout="inline" @keyup.enter.native="submitPayoutBatch">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6">
          <a-form-item :label="'类型'">
            <a-select default-value='' style='width: 120px' v-model='submitParam.loanType'>
              <a-select-option value=''>
                全部
              </a-select-option>
              <a-select-option value='1'>
                首贷
              </a-select-option>
              <a-select-option value='2'>
                复贷
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6" :md="6" :sm="8">
          <a-form-item :label="'产品类型'">
            <a-select
              v-model='submitParam.appSsid'
              mode='multiple'
            >
              <a-select-option v-for='item in appList' :key='item.appssid'>
                {{ item.appName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="4" :sm="6">
        <a-form-item :label="'排序'">
          <a-select default-value='' style='width: 120px' v-model='submitParam.sort'>
            <a-select-option value=''>
              正序
            </a-select-option>
            <a-select-option value='1'>
              倒序
            </a-select-option>
          </a-select>
        </a-form-item>
        </a-col>
        <a-col :md="3" :sm="4">
          <a-form-item :label="'放款笔数'">
            <a-input v-model="submitParam.limit"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="3" :sm="4">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="submitPayoutBatch" >{{ '发起放款' }}</a-button>
            </span>
        </a-col>
      </a-row>
      </a-form>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { listOrderNumber,countOrderSelected,createBatch } from '@/webpublicapi/payoutBank'
import { getApplist } from '@/webpublicapi/order'
const I18N_KEY = 'order.';
export default {
  name: 'listOrderNumber',
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        loanType: '',
        appSsid: '',
      },
      // 提交条件
      submitParam: {
        loanType: '',
        appSsid: '',
        sort: '',
        limit: 99,
      },
      loading: false,
      // 表头
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '盘号',
          align: 'left',
          dataIndex: 'app_ssid'
        },
        {
          title: '订单总数',
          align: 'left',
          dataIndex: 'total'
        },
        {
          title: '首贷',
          align: 'left',
          dataIndex: 'new'
        },
        {
          title: '复贷',
          align: 'left',
          dataIndex: 'old'
        },
        {
          title: '申请金额',
          align: 'left',
          dataIndex: 'amount'
        },
        {
          title: '待放款金额',
          align: 'left',
          dataIndex: 'payoutAmount'
        },
      ]
    },
  },
  created () {
    getApplist().then(res => {
      this.appList = res.data || []
    })
    this.loadData(1)
  },
  methods: {
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      const params = this.getQueryParams()// 查询条件
      listOrderNumber(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.dataSource = res.data
        }else{
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    getQueryParams () {

      const data = {
        ...this.queryParam,
      }

      const param = Object.assign({}, data)

      return filterObj(param)
    },
    submitPayoutBatch (arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      const params = this.getSubmitParams()// 查询条件

      countOrderSelected(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.$confirm({
            title: '确认放款',
            content: "本批次共选择" + res.data.total + "条放款数据, 预估放款金额： " + res.data.amount + ", 是否确认放款？",
            onOk: () => {
              createBatch(Object.assign({}, params)).then((res)=>{
                if(res.code===1000){
                  this.$message.info("批次创建成功，生成" + res.data.rows + "条有效放款数据")
                }else{
                  this.$message.error(res.msg)
                }
              }).catch(e => {
                this.$message.error(e.message);
              })

              this.loadData(1)
            },
            onCancel: () => {
              this.loading = false
            }
          })
        }else{
          this.$message.error(res.msg)
          this.loading = false
        }
      }).catch(e => {
        this.$message.error(e.message);
        this.loading = false
      })

    },
    getSubmitParams () {

      const data = {
        ...this.submitParam,
      }

      const param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // 重置字典类型搜索框的内容
    searchReset () {
      const that = this
      that.queryParam.appSsid = ''
      that.queryParam.loanType = ''

    },
    changeModal (visible) {
        this.visible = visible;
    }
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
